import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SocialIcon from './icon'
import InstagramIcon from '../../images/ico-instagram.svg'
import FacebookIcon from '../../images/ico-facebook.svg'

class Social extends Component {
  render() {
    const { instagram, facebook } = this.props

    return (
      <div className="social">
        { instagram &&
          <SocialIcon url={ 'http://www.instagram.com/' + instagram } icon={ InstagramIcon } />
        }

        { facebook &&
          <SocialIcon url={ 'http://www.facebook.com/' + facebook } icon={ FacebookIcon } />
        }
      </div>
    );
  }
}

Social.propTypes = {
  instagram: PropTypes.string,
  facebook: PropTypes.string
}

export default Social;



// WEBPACK FOOTER //
// ./src/components/social/index.js